export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

function absoluteUrlFromPath(relativePath, appendQueryParams) {
  var absoluteUrl = window.location.protocol + '//' + window.location.host + '/' + relativePath;

  if (appendQueryParams) {
    absoluteUrl += window.location.search;
  }

  return absoluteUrl;
}

export function createProductUrlFromHandle(productHandle) {
  return absoluteUrlFromPath('products/' + productHandle, false);
}

export function getSiteCode() {
  switch(window.theme.permanent_domain) {
    case "space-furniture-au.myshopify.com":
      return "au";
    case "space-furniture-sg.myshopify.com":
      return "sg";
  }
}

document.addEventListener("DOMContentLoaded", function(e) {
  document.querySelectorAll('[data-slick-slider]').forEach((slider) => {
    jQuery(slider).slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });
  });
}, false);